const $el = $('.nav-icon');
// const $exit = $('.nav-exit');
const $nav = $('.banner-nav');
const $banner = $('.banner');

function isOpen() {
  if ($('body').hasClass('is-nav')) {
    return true;
  }
}

function toggle() {
  $('body').toggleClass('is-nav');
}

function release() {
  if (isOpen()) {
    toggle();
  }
}

function leaving() {
  $('body').animate({ scrollTop: 0 }, 200);
  $('body').addClass('is-leaving');
}

function handler(event) {
  event.preventDefault();
  toggle();
}

function handlerHref(event) {
  event.preventDefault();
  let loc = $(this).attr('href');
  release();
  leaving();
  $(window).delay(200).queue((next) => {
    window.location = loc;
    next();
  });
}

function init() {
  $el.on('click', handler);
  // $exit.on('click', release);
  $nav.on('click', 'a', handlerHref);
  $banner.on('click', 'a', handlerHref);
}

export default {
  init,
  release,
}



// WEBPACK FOOTER //
// ./scripts/comps/nav.js